<template>
  <div>
    <div v-if="getCircuits.length > 0">
      <gmap-info-window
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
        style="gmap-info-window-vue"
      >
        <div class="infoWindow">
          <div v-html="infoOptions.content"></div>
        </div>
      </gmap-info-window>

      <div v-for="(data, i) in getCircuits" :key="i">
        <!-- DATA FOR CIRCUITS -->
        <gmap-polyline
          v-for="(options, i) in data.arrResPolyline"
          :key="i"
          v-bind:path="options.path"
          :options="options"
        />
        <!-- deepWatch -->

        <!-- Banco de condensadores -->
        <gmap-marker
          :key="i + '_Banco_'"
          v-for="(item, i) in data.bdiv10_bdi_banco"
          :visible="zoom > 17"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getFormatIcon(item.icon)"
          @click="toggleInfoWindow(item, i)"
        />
        <gmap-polyline
          v-for="(options, i) in data.bdiv10_bdi_banco"
          :key="`${i}_${options.details.codigo_elemento}`"
          v-bind:path="options.path"
          :visible="zoom > 17"
          :options="options"
          :clickable="true"
          @click="toggleInfoWindow(options, i)"
        />

        <!-- Fusibles -->
        <!-- <gmap-marker
          :key="`${i}_fusible`"
          v-for="(item, i) in data.bdiv10_bdi_fusib"
          :visible="zoom > 15"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getIconFusible(item.icon)"
          @click="toggleInfoWindow(item, i)"
        /> -->
        <div v-if="zoom > 17">
          <gmap-polyline
            v-for="(options, i) in data.bdiv10_bdi_fusib"
            :key="`${i}_${options.details.codigo_elemento}`"
            v-bind:path="options.path"
            :options="options"
            :clickable="true"
            @click="toggleInfoWindow(options, i)"
          />
        </div>

        <!-- Centros de transformación -->
        <gmap-marker
          :key="`${i}_centro`"
          v-for="(item, i) in data.bdiv10_sgd_ct"
          :visible="zoom > 17"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getFormatIcon(item.icon)"
          @click="toggleInfoWindow(item, i)"
        />
        <gmap-polyline
          v-for="(options, i) in data.bdiv10_sgd_ct"
          :key="`${i}_${options.details.codigo_elemento}`"
          v-bind:path="options.path"
          :options="options"
          :clickable="true"
          @click="toggleInfoWindow(options, i)"
        />

        <!-- Disyuntores -->
        <!-- <gmap-marker
          :key="`${i}_disyuntor`"
          v-for="(item, i) in data.bdiv10_sgd_disyun"
          :visible="zoom > 15"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getFormatIcon(item.icon)"
          @click="toggleInfoWindow(item, i)"
        /> -->
        <div v-if="zoom > 17">
          <gmap-polyline
            v-for="(options, i) in data.bdiv10_sgd_disyun"
            :key="`${i}_${options.details.codigo_elemento}`"
            v-bind:path="options.path"
            :options="options"
            :clickable="true"
            @click="toggleInfoWindow(options, i)"
          />
        </div>

        <!-- Interruptores -->
        <!-- <gmap-marker
          :key="`${i}_interruptor`"
          v-for="(item, i) in data.bdiv10_sgd_interr"
          :visible="zoom > 15"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getFormatIcon(item.icon)"
          @click="toggleInfoWindow(item, i)"
        /> -->
        <div v-if="zoom > 17">
          <gmap-polyline
            v-for="(options, i) in data.bdiv10_sgd_interr"
            :key="`${i}_${options.details.codigo_elemento}`"
            v-bind:path="options.path"
            :options="options"
            :clickable="true"
            @click="toggleInfoWindow(options, i)"
          />
        </div>

        <!-- Pararayo -->
        <gmap-marker
          :key="`${i}_pararayo`"
          v-for="(item, i) in data.bdiv10_sgd_pararrayo"
          :visible="zoom > 17"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getFormatIcon(item.icon)"
          @click="toggleInfoWindow(item, i)"
        />
        <gmap-polyline
          v-for="(options, i) in data.bdiv10_sgd_pararrayo"
          :key="`${i}_${options.details.codigo_elemento}`"
          v-bind:path="options.path"
          :options="options"
          :clickable="true"
          @click="toggleInfoWindow(options, i)"
        />

        <!-- Puente -->
        <!-- <gmap-marker
          :key="`${i}_puente`"
          v-for="(item, i) in data.bdiv10_sgd_puente"
          :visible="zoom > 15"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getIconPuente(item.icon)"
          @click="toggleInfoWindow(item, i)"
        /> -->
        <div v-if="zoom > 17">
          <gmap-polyline
            v-for="(options, i) in data.bdiv10_sgd_puente"
            :key="`${i}_${options.details.codigo_elemento}`"
            v-bind:path="options.path"
            :clickable="true"
            :options="options"
            @click="toggleInfoWindow(options, i)"
          />
        </div>

        <!-- Regulador -->
        <gmap-marker
          :key="`${i}_regulador`"
          v-for="(item, i) in data.bdiv10_sgd_regulador"
          :visible="zoom > 17"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getFormatIcon(item.icon)"
          @click="toggleInfoWindow(item, i)"
        />
        <gmap-polyline
          v-for="(options, i) in data.bdiv10_sgd_regulador"
          :key="`${i}_${options.details.codigo_elemento}`"
          v-bind:path="options.path"
          :clickable="true"
          :visible="zoom > 17"
          :options="options"
          @click="toggleInfoWindow(options, i)"
        />

        <!-- Seccionador -->
        <!-- <gmap-marker
          :key="`${i}_seccionador`"
          v-for="(item, i) in data.bdiv10_sgd_secci"
          :visible="zoom > 15"
          :position="item.position"
          :clickable="true"
          :animation="2"
          :icon="getFormatIcon(item.icon)"
          @click="toggleInfoWindow(item, i)"
        /> -->
        <div v-if="zoom > 17">
          <gmap-polyline
            v-for="(options, i) in data.bdiv10_sgd_secci"
            :key="`${i}_${options.details.codigo_elemento}`"
            v-bind:path="options.path"
            :clickable="true"
            :options="options"
            @click="toggleInfoWindow(options, i)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import infoWinCircuit from "../../../assets/content/operative/infoWinCircuit.js";

export default {
  props: {
    zoom: {
      type: Number,
      default: () => 10,
    },
  },
  data() {
    return {
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoWinContent: null,

      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: 0,
        },
      },
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      getCircuits: "network/getCircuits",
      oSeeElement: "network/getSeeElement",
    }),
  },
  methods: {
    ...mapActions({
      onUpdateSeeElement: "network/onUpdateSeeElement",
    }),
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.center = marker.position;
      this.infoOptions.content = infoWinCircuit(marker.details);
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getFormatIcon(icon) {
      return {
        url: icon,
        // scale: 10,
        // size: { width: 15, height: 15, f: 'px', b: 'px', },
        scaledSize: { width: 12, height: 12, f: "px", b: "px" },
        // anchor: new google.maps.Point(16, 16),
        // scaledSize: new google.maps.Size(32, 32),
        // rotation: 65,
      };
    },
    findElementForCircuit(data) {
      if (
        this.oSeeElement.isSearch &&
        this.oSeeElement.codigo_elemento !== null &&
        this.oSeeElement.type !== null
      ) {
        const arrElements = data[0];
        let aElementsAll = [];
        let aTempt = [];
        for (const key in arrElements) {
          if (key !== "arrResPolyline" && key !== "codigo_circuito") {
            aTempt = arrElements[key].map((element, idx) => ({
              ...element,
              idx,
              key,
            }));
            aElementsAll = [...aElementsAll, ...aTempt];
          }
        }
        const [findElement] = aElementsAll.filter(
          (element) =>
            element.details[this.oSeeElement.type] ===
            this.oSeeElement.codigo_elemento
        );
        
        if (findElement) {
          this.toggleInfoWindow(findElement, findElement.idx);
          this.$emit("onNewZoomForElement");
          this.onUpdateSeeElement({ isSearch: false, codigo_elemento: null });
        } else {
          this.$swal.fire({
            title: `No se pudo encontrar el elemento del circuito ${this.oSeeElement.type} = ${this.oSeeElement.codigo_elemento}`,
            icon: "warning",
            confirmButtonText: "Ok, entiendo",
          });
        }
      }
    },
  },
  watch: {
    getCircuits(newValue) {
      this.findElementForCircuit(newValue);
    },
  },
};
</script>
